import {
  ExperimentGroupEnum,
  FlowTypes,
  GiftingDesignationTypes,
  IRATrustTypes,
  YesNoEmpty,
} from '@interfaces/models';
import { AccountTypes } from '@interfaces/models/account-types';
import { IndividualDesignationListedTypes } from '@interfaces/models/individual-designation-types';
import { IRADesignationListedTypes } from '@interfaces/models/ira-designation-types';

export interface TriageState {
  isClient: string;
  isSpouse: string;
  isDecedentMarried: YesNoEmpty;
  isSingleExecutor: YesNoEmpty;
  isExecutorDecedentsSpouse: YesNoEmpty;
  accountTypeInheriting: AccountTypes;
  IRADesignation: IRADesignationListedTypes;
  individualDesignation: IndividualDesignationListedTypes;
  giftingDesignation: GiftingDesignationTypes;
  flowType: FlowTypes;
  experimentGroup: ExperimentGroupEnum;
  isTrusteeOrg: YesNoEmpty;
  isSingleTrustee: YesNoEmpty;
  typeOfTrust: IRATrustTypes;
  isUpdatingTrust: boolean;
  isUpdatingTrustee: boolean;
  isSuccessorOrLivingTrustee: YesNoEmpty;
  hasPassedAway: YesNoEmpty;
  isTrustReportingUnderDecedentsSSN: YesNoEmpty;
  isTrusteeOrEstate: YesNoEmpty;
  isInheritingMultipleAccounts: YesNoEmpty;
}
